import { useMutation } from 'react-query'

import { accountStylesService } from 'src/services/account-styles.service'
import { ICreateStylesForm } from 'src/types'

interface IProps {
	accountId: string
}

export const useCreateAccountStyles = ({ accountId }: IProps) => {
	return useMutation((dto: ICreateStylesForm) =>
		accountStylesService.createStyling({ accountId, file: dto.file }),
	)
}
